import {Component, OnInit} from "@angular/core";
import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {ValidationService} from "../../services/validation.service";
import {Conf} from "../../settings/config";
import {AuthServices} from "../../services/auth.service";
import {User} from "../../models/user.model";
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {LoginComponent} from "../login/login.component";


@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html'
})
export class SignupComponent implements OnInit {

    public auth_user = new User();
    regForm: FormGroup;
    error = {
        username: '',
        email: '',
        password: '',
        login: '',
    };

    constructor(private authService: AuthServices,
                public activeModal: NgbActiveModal,
                private fb: FormBuilder,
                private http: HttpClient,
                public _auth: AuthService,
                private modalService: NgbModal) {
        this.regForm = fb.group({
            'email': [null, [Validators.required, ValidationService.emailValidator]],
            'password': [null, Validators.required],
            'username': [null, [Validators.required]],
        });
        this.regForm['submitted'] = false;
    }

    ngOnInit() {

    }

    clickSignUp() {
        this.regForm['submitted'] = true;
        if (this.regForm.valid) {
            this.http.post(Conf.API_URL + '/auth-users/register/', {
                username: this.regForm.value.username,
                email: this.regForm.value.email,
                password: this.regForm.value.password
            }).subscribe(
                data => {
                    console.log(data)
                    this.auth_user.email = this.regForm.value.username;
                    this.auth_user.username = this.regForm.value.email;
                    this.auth_user.id = data['id'];
                    this.auth_user.pk = data['pk'];
                    this.auth_user.token = data['token'];
                    this.authService.setAuth(this.auth_user);
                    this.closePopup();
                },
                error => {
                    var this_e = this;
                    $.each(error.error, function (index, value) {
                        if (value[0] == 'This field may not be null.') {
                            value[0] = 'This field is required'
                        }
                        this_e.error[index] = value[0];
                    })

                }
            );
        }
    }

    socialLogin(provider) {
        this._auth.login(provider).subscribe(
            (dataSocial) => {
                console.log(dataSocial)

                this.auth_user.email = dataSocial['email'];
                this.auth_user.name = dataSocial['name'] ? dataSocial['name'] : '';
                this.auth_user.username = dataSocial['email'];
                this.auth_user.image = dataSocial['image'] ? dataSocial['image'] : '';

                this.closePopup();

                this.http.post(Conf.API_URL + '/auth-users/social-login/', {
                    email: dataSocial['email'],
                    provider: dataSocial['provider'],
                    uid: dataSocial['uid'],
                    name: dataSocial['name'] ? dataSocial['name'] : '',
                    social_image: dataSocial['image'] ? dataSocial['image'] : '',
                }).subscribe(
                    data => {
                        console.log(data)
                        this.auth_user.username = data['username'];
                        this.auth_user.id = data['id'];
                        this.auth_user.pk = data['pk'];
                        this.auth_user.token = data['token'];
                        this.authService.setAuth(this.auth_user);

                    },
                    error => {
                        console.log(error);
                    }
                );
            }
        );
    }

    closePopup() {
        this.error = {
            username: '',
            email: '',
            password: '',
            login: '',
        };
        this.activeModal.close();
    }

    openLogin() {
        this.closePopup();
        this.modalService.open(LoginComponent, {size: "sm"});
    }

    get email(): AbstractControl {
        return this.regForm.get('email');
    }

    get password(): AbstractControl {
        return this.regForm.get('password');
    }

    get username(): AbstractControl {
        return this.regForm.get('username');
    }

}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/dialogs/signup/signup.component.ts